import TabMenu from "primevue/tabmenu";

// TabMenu queues updateInkBar() in a $nextTick from mounted() and calls it again
// from updated(). Neither is guarded against the component having been unmounted
// in between, and Vue nulls $refs on unmount, so any mount-then-unmount inside a
// single tick throws "Cannot read properties of null (reading 'children')" from
// vendor code with no app frame in the stack. Guard the deref instead of relying
// on every call site to keep the component alive.
export default defineNuxtPlugin(() => {
  const updateInkBar = (TabMenu as any).methods?.updateInkBar;

  if (typeof updateInkBar !== "function") return;

  (TabMenu as any).methods.updateInkBar = function (this: any, ...args: unknown[]) {
    if (!this.$refs?.nav || !this.$refs?.inkbar) return;

    return updateInkBar.apply(this, args);
  };
});
